<template>
  <div>
    <vx-tooltip :text="actn.platformCode === 'custom' ? actn.actionText : actionsMappedToText[actn.platformCode]" class="inline-block" v-for="(actn, i) in activeActions" :key="String(i) + 'actn'">
    <component v-if="actn.platformCode !== 'custom'"
      :is="actn.platformCode"
      class="inline-block mr-2 w-5 h-5"
    /><div class="w-5 h-5 mr-2 inline-block" v-else>
            <img class="w-full" v-if="actn.actionImageType === 'img'" :src="actn.actionImageData"/>
            <span class="svgwrappolist w-full" v-if="actn.actionImageType === 'svg'" v-html="actn.actionImageData"></span>
      </div>
    </vx-tooltip>
  </div>
</template>

<script>

// @ts-nocheck

import Vue from 'vue'
import Googlereview from "../../../platformlogos/Googlereview.vue";
import Facebook from "../../../platformlogos/Facebook.vue";
import Tripadvisor from "../../../platformlogos/Tripadvisor.vue";
import Capterra from "../../../platformlogos/Capterra.vue";
import Foursquare from "../../../platformlogos/Foursquare.vue";
import G2 from "../../../platformlogos/G2.vue";
import Trustpilot from "../../../platformlogos/Trustpilot.vue";
import Twitter from "../../../platformlogos/Twitter.vue";
import Yelp from "../../../platformlogos/Yelp.vue";

export default Vue.extend({
    props: {
        activeActions: Array //{ platformCode: 'fbs'}, ...
    },
    data() {
        return {
            actionsMappedToText: {
                fbr: "Facebook Review",
                fbs: "Facebook Share ",
                gp: "Google Review",
                tw: "Tweet",
                tp: "Trustpilot Review",
                g2: "G2 Review",
                ca: "Capterra Review",
                ta: "Tripadvisor Review",
                ye: "Yelp Review",
                fs: "Foursquare Review",
                }
            }
    },
    components: {
        gp: Googlereview,
        fbr: Facebook,
        fbs: Facebook,
        ta: Tripadvisor,
        ca: Capterra,
        fs: Foursquare,
        g2: G2,
        tp: Trustpilot,
        tw: Twitter,
        ye: Yelp
    }
})

</script>

<style lang="scss">

.svgwrappolist {
  display: inline-block;
  svg {
    width: 4rem;
  }
  &.w-full {
   svg {
    width: 100%;
    display: block;    
    &.customsvg{
      path {
      stroke: black !important;
      }     
    }
    
   } 
  }

}



</style>